import { render, staticRenderFns } from "./GroupMobileOrdered.vue?vue&type=template&id=5906be40"
import script from "./GroupMobileOrdered.vue?vue&type=script&lang=js"
export * from "./GroupMobileOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports